// import { authHeader } from './auth-header';
import api from '../api'

import axios from 'axios'

import endpoint from '../endpoint';
import router from '../../router';

class UserService{

   async login(email, password) {
        console.log("this is the login  reached");

        return await  axios.post(`${endpoint}/auth/login`, {email,password},{
            withCredentials: false,
            headers: { 'Content-Type': 'application/json' }
        }).then(
            response => {
            if (response.data.token) {
                localStorage.setItem('user', JSON.stringify(response.data.user));
                localStorage.setItem('ENSPSID', response.data.token);

            }
            return response.data;
        })
    }

    async logout() {
        return await api.post('/auth/logout').then(
            response => {
                localStorage.removeItem('ENSPSID')
                return response.data
            }
        );
      
    }

    async verifyUser(){
        return await  api.get(`${endpoint}/auth/verify_token`,{headers: { 'Content-Type': 'application/json' }}).then(
            response => {
                // store this token and refresh token 
            return response.data;
        }).catch(() =>{
            router.push('/login')
        })
    }

    async createUser(user) {
        console.log(user);
        return await api.post(`/auth/register`, user ,{headers: { 'Content-Type': 'application/json' }}).then(
            response =>{
                response.data
            }
        )
    }

    async editUser(user) {

        return await api.put(`/user/${user.id}`, user,{headers: { 'Content-Type': 'application/json' }}).then(
            response =>{
                response.data
            }
        )
    }


    async forgotPassword(email){
        return await  axios.post(`${endpoint}/auth/sendResetPasswordCode`, {email},{headers: { 'Content-Type': 'application/json' }}).then(
            response => {
    
            // console.log(response.data)
            return response.data;
        })
    }


    async verifyOTP(code){
        return await  axios.post(`${endpoint}/auth/checkCode`, {code:code.toString()},{headers: { 'Content-Type': 'application/json' }}).then(
            response => {
                localStorage.setItem('enspsid', JSON.stringify(code));
            return response.data;
        })
    }

    // async resetPassword(password){
    //     let code = localStorage.getItem('enspsid');
    //     return await  axios.post(`${endpoint}/auth/passwordReset`, {code:code.toString(),password:password},{headers: { 'Content-Type': 'application/json' }}).then(
    //         response => {
    //         localStorage.removeItem('enspsid');
    //         return response.data;
    //     })
    // }
    async changePassword(form){
        return await  api.post(`/user/change-password`, {
            old_password:form.old,
            new_password:form.new
        }).then(
            response => {
            return response.data;
        })
    }
    async resetPassword(form){
        return await  api.post(`/user/${form.id}/reset-password`).then(
            response => {
            return response.data;
        })
    }

    async getAllUsers() {
        return await api.get('/users').then().then(
            response => {
                return response.data
            }
        )
    }

    async getUser(id){
        return await api.get(`/user/${id}`,{id}).then(
            response => {
                return response.data
            }
        )
    }

    async searchUsers(query) {
        return api.get(`/users/search?q=${encodeURIComponent(query)}`)
    }

    async getRoles(){
        return await api.get('/roles').then(
            response =>{
                return response.data
            }
        )
    }

        async assign_role(data){
        return await api.post(`/assign-role`, data).then(
            response =>{
                return response.data
            }
        )
    }
    async remove_role(data){
        return await api.post(`/unassign-role`, data).then(
            response =>{
                return response.data
            }
        )
    }

    async addUserPermission(permission){
        return await api.post('/add-permissions',{permission:permission}).then(
            response =>{
                return response.data
            }
        )
    }
    async deleteUserPermission(id){
        return await api.post('/delete-permissions',{id:id}).then(
            response =>{
                return response.data
            }
        )
    }

    async getPermissions(){
        return await api.get('/permissions').then(
            response =>{
                return response.data
            }
        )
    }
    
    async updateUserPermissions(permissions, id){
        return await api.post('/update_permissions',{
            permissions: permissions,
            user_id:id
        }).then(
            response =>{
                return response.data
            }
        )
    }
    

    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    // auto logout if 401 response returned from api
                    // this.logout();
                    // location.reload(true);
                }
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            return data;
        });
    }


}

export default new UserService